export const bitN = (a) => ~a;

export const bitA = (...args) => {
  let result = -1 | 0; // supposed to be the max integer, all ones, no zeroes in it
  for (const arg of args) result &= arg;
  return result;
};

export const bitO = (...args) => {
  let result = 0 | 0; // supposed to be all zeroes
  for (const arg of args) result |= arg;
  return result;
};

export const lgcN = (a) => !a;

export const lgcA = (...args) => {
  let result = true;
  for (const arg of args) result &&= !!arg;
  return result;
};

export const lgcO = (...args) => {
  let result = false;
  for (const arg of args) result ||= !!arg;
  return result;
};
